import { useContext, useEffect, useState } from "react";

import { MaskedInput } from "~/components/TextInput";
import type { MargariaProtocol } from "~/modules/aerobicCapabilities/schema";
import { patchEvaluationAtom } from "~/modules/evalutation/services";
import { studentEvaluationDemoContext } from "~/pages/authenticated/personalTrainer/studentEvaluationDemo";

export const Margaria: React.FC = () => {
	const { data } = useContext(studentEvaluationDemoContext);
	const [value] = useState<MargariaProtocol>({
		distance: data?.margaria?.distance ?? 0,
		time: data?.margaria?.time ?? 0,
	});

	useEffect(() => {
		patchEvaluationAtom({ margaria: value });
	}, [value]);

	return (
		<div className="flex gap-3">
			<MaskedInput
				mask="float"
				inputMode="numeric"
				label="Tempo (min)"
				placeholder="0"
				value={value?.time}
				onChange={() => undefined}
			/>
			<MaskedInput
				mask="integer"
				inputMode="numeric"
				label="Distância (m)"
				placeholder="0"
				value={value?.distance}
				onChange={() => undefined}
			/>
		</div>
	);
};
